// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.diff-modal .modal-content.diff-modal-content {
  height: 90vh;
}

.diff-modal .modal-body {
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.diff-content-section {
  padding: 12px 14px;
  overflow: auto;
  min-height: 0;
}

.diff-form {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.diff-form__toggle {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  padding: 8px 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.diff-form__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.current-section,
.add-panel {
  height: 100%;
  margin: 16px;
  overflow: auto;
}

.view-switch {
  display: block;
  width: 100%;
  user-select: none;
}
.view-switch input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.view-switch__track {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 999px;
  padding: 6px;
  overflow: hidden;
}
.view-switch__option {
  text-align: center;
  font-weight: 600;
  padding: 6px 8px;
  line-height: 1;
  z-index: 1;
}
.view-switch__option.is-active {
  color: #0f5132;
}
.view-switch__thumb {
  position: absolute;
  inset: 4px;
  width: calc(50% - 4px);
  border-radius: 999px;
  background: #d1e7dd;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
  transform: translateX(0%);
  transition: transform 160ms ease;
}
.view-switch input:checked + .view-switch__track .view-switch__thumb {
  transform: translateX(100%);
}

.add-panel__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  margin-top: 8px;
}
.add-panel__tabs .tab-button,
.add-panel__tabs .tab-button-selected {
  min-width: 64px;
  border-radius: 10px;
  padding: 0.25rem 0.75rem;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03);
}

.add-panel__tabs--inset {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.75rem 1rem 0.5rem;
  background: #ffffff;
  border-bottom: 1px solid #f0f2f5;
}

.section-helper {
  border: 2px solid #00AEEF;
  border-radius: 5px;
  font-weight: 500;
  margin: 8px 0 16px;
  padding: 16px;
}

.diff-standard-card {
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  overflow: hidden;
}
.diff-standard-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-align: left;
  background: #f8f9fa;
  border: none;
  border-bottom: 1px solid #d0d5dd;
  padding: 10px 14px;
  font-size: 0.95rem;
  font-weight: 600;
  color: #1a1a2e;
  cursor: pointer;
}
.diff-standard-card__header:hover {
  background: #eef0f3;
}
.diff-standard-card__chevron {
  font-size: 0.85rem;
  color: #6c757d;
  flex-shrink: 0;
}
.diff-standard-card__body {
  padding: 8px 12px 4px;
  background: #fff;
}

.diff-gle-row {
  border-left: 3px solid #adb5bd;
  margin: 8px 0;
  padding: 6px 0 6px 10px;
}
.diff-gle-row__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}
.diff-gle-row__label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #212529;
  flex: 1;
  line-height: 1.4;
}
.diff-gle-row__short-name {
  color: #495057;
}
.diff-gle-row__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.diff-eo-block {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin: 6px 0 6px 8px;
  padding: 8px 10px;
}
.diff-eo-block__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.diff-eo-block__content {
  flex: 1;
  font-size: 0.875rem;
  color: #212529;
  line-height: 1.45;
}
.diff-eo-block__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.diff-eoc-list {
  margin-top: 6px;
  padding-left: 12px;
  border-left: 2px dashed #ced4da;
}

.diff-eoc-block {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  margin-top: 4px;
  padding: 6px 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.diff-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-radius: 4px;
  padding: 1px 5px;
  margin-right: 6px;
  vertical-align: middle;
  white-space: nowrap;
}
.diff-badge--gle {
  background: #e8f4e8;
  color: #2d6a2d;
  border: 1px solid #b8ddb8;
}
.diff-badge--eo {
  background: #fff3cd;
  color: #664d03;
  border: 1px solid #ffe69c;
}
.diff-badge--eoc {
  background: #cff4fc;
  color: #055160;
  border: 1px solid #9eeaf9;
}
.diff-badge--on-template {
  background: #e9ecef;
  color: #495057;
  border: 1px solid #ced4da;
  font-weight: 600;
}

.diff-action-btn {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 2px 10px;
  border-radius: 4px;
  border: 1px solid #0669B3;
  color: #0669B3;
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: background 120ms, color 120ms;
}
.diff-action-btn:hover {
  background: #e8f1fb;
}
.diff-action-btn--active {
  background: #0669B3;
  color: #fff;
}
.diff-action-btn--active:hover {
  background: #0558a0;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/StudentDiffForm.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AALA;EACE,YAAA;AAQF;;AALA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAQF;;AALA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;AAQF;;AALA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAQF;AANE;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;AAQJ;AALE;EACE,cAAA;EACA,aAAA;EACA,gBAAA;AAOJ;;AAHA;;EAEE,YAAA;EACA,YAAA;EACA,cAAA;AAMF;;AADA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AAIF;AAFE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AAIJ;AADE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qCAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAEJ;AAAI;EAAc,cAAA;AAGlB;AAAE;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,+CAAA;EACA,yBAAA;EACA,gCAAA;AAEJ;AACE;EACE,2BAAA;AACJ;;AAKA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAFF;AAIE;;EAEE,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,uCAAA;AAFJ;;AAMA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,4BAAA;EACA,mBAAA;EACA,gCAAA;AAHF;;AAQA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AALF;;AAUA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AAPF;AASE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAPJ;AASI;EAAU,mBAAA;AANd;AASE;EACE,kBAAA;EACA,cAAA;EACA,cAAA;AAPJ;AAUE;EACE,qBAAA;EACA,gBAAA;AARJ;;AAcA;EACE,8BAAA;EACA,aAAA;EACA,uBAAA;AAXF;AAaE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AAXJ;AAcE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,gBAAA;AAZJ;AAeE;EACE,cAAA;AAbJ;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAdJ;;AAoBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAjBF;AAmBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AAjBJ;AAoBE;EACE,OAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAnBJ;;AAyBA;EACE,eAAA;EACA,kBAAA;EACA,+BAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AAtBF;;AA2BA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AAxBF;AA0BE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAxBJ;AA2BE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAzBJ;AA4BE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA1BJ;AA6BE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AA3BJ;;AAiCA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,yCAAA;AA9BF;AAgCE;EACE,mBAAA;AA9BJ;AAiCE;EACE,mBAAA;EACA,WAAA;AA/BJ;AAiCI;EAAU,mBAAA;AA9Bd","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n// ─── Modal shell ────────────────────────────────────────────────────────────\n\n.diff-modal .modal-content.diff-modal-content {\n  height: 90vh;\n}\n\n.diff-modal .modal-body {\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n}\n\n.diff-content-section {\n  padding: 12px 14px;\n  overflow: auto;\n  min-height: 0;\n}\n\n.diff-form {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  &__toggle {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: #fff;\n    padding: 8px 0 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  }\n\n  &__body {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow: hidden;\n  }\n}\n\n.current-section,\n.add-panel {\n  height: 100%;\n  margin: 16px;\n  overflow: auto;\n}\n\n// ─── Toggle switch ───────────────────────────────────────────────────────────\n\n.view-switch {\n  display: block;\n  width: 100%;\n  user-select: none;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  &__track {\n    position: relative;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    align-items: center;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 999px;\n    padding: 6px;\n    overflow: hidden;\n  }\n\n  &__option {\n    text-align: center;\n    font-weight: 600;\n    padding: 6px 8px;\n    line-height: 1;\n    z-index: 1;\n\n    &.is-active { color: #0f5132; }\n  }\n\n  &__thumb {\n    position: absolute;\n    inset: 4px;\n    width: calc(50% - 4px);\n    border-radius: 999px;\n    background: #d1e7dd;\n    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);\n    transform: translateX(0%);\n    transition: transform 160ms ease;\n  }\n\n  input:checked + .view-switch__track .view-switch__thumb {\n    transform: translateX(100%);\n  }\n}\n\n// ─── Grade tabs ──────────────────────────────────────────────────────────────\n\n.add-panel__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 0.75rem;\n  margin-top: 8px;\n\n  .tab-button,\n  .tab-button-selected {\n    min-width: 64px;\n    border-radius: 10px;\n    padding: 0.25rem 0.75rem;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03);\n  }\n}\n\n.add-panel__tabs--inset {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 0.75rem 1rem 0.5rem;\n  background: #ffffff;\n  border-bottom: 1px solid #f0f2f5;\n}\n\n// ─── Helper banner ───────────────────────────────────────────────────────────\n\n.section-helper {\n  border: 2px solid $information;\n  border-radius: 5px;\n  font-weight: 500;\n  margin: 8px 0 16px;\n  padding: 16px;\n}\n\n// ─── Standard card ───────────────────────────────────────────────────────────\n\n.diff-standard-card {\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  overflow: hidden;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    text-align: left;\n    background: #f8f9fa;\n    border: none;\n    border-bottom: 1px solid #d0d5dd;\n    padding: 10px 14px;\n    font-size: 0.95rem;\n    font-weight: 600;\n    color: #1a1a2e;\n    cursor: pointer;\n\n    &:hover { background: #eef0f3; }\n  }\n\n  &__chevron {\n    font-size: 0.85rem;\n    color: #6c757d;\n    flex-shrink: 0;\n  }\n\n  &__body {\n    padding: 8px 12px 4px;\n    background: #fff;\n  }\n}\n\n// ─── GLE row ─────────────────────────────────────────────────────────────────\n\n.diff-gle-row {\n  border-left: 3px solid #adb5bd;\n  margin: 8px 0;\n  padding: 6px 0 6px 10px;\n\n  &__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 4px;\n  }\n\n  &__label {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #212529;\n    flex: 1;\n    line-height: 1.4;\n  }\n\n  &__short-name {\n    color: #495057;\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n  }\n}\n\n// ─── EO block ────────────────────────────────────────────────────────────────\n\n.diff-eo-block {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  margin: 6px 0 6px 8px;\n  padding: 8px 10px;\n\n  &__row {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  &__content {\n    flex: 1;\n    font-size: 0.875rem;\n    color: #212529;\n    line-height: 1.45;\n  }\n\n  &__actions {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n  }\n}\n\n// ─── EOC block ───────────────────────────────────────────────────────────────\n\n.diff-eoc-list {\n  margin-top: 6px;\n  padding-left: 12px;\n  border-left: 2px dashed #ced4da;\n}\n\n.diff-eoc-block {\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 5px;\n  margin-top: 4px;\n  padding: 6px 10px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n// ─── Shared badges ───────────────────────────────────────────────────────────\n\n.diff-badge {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  border-radius: 4px;\n  padding: 1px 5px;\n  margin-right: 6px;\n  vertical-align: middle;\n  white-space: nowrap;\n\n  &--gle {\n    background: #e8f4e8;\n    color: #2d6a2d;\n    border: 1px solid #b8ddb8;\n  }\n\n  &--eo {\n    background: #fff3cd;\n    color: #664d03;\n    border: 1px solid #ffe69c;\n  }\n\n  &--eoc {\n    background: #cff4fc;\n    color: #055160;\n    border: 1px solid #9eeaf9;\n  }\n\n  &--on-template {\n    background: #e9ecef;\n    color: #495057;\n    border: 1px solid #ced4da;\n    font-weight: 600;\n  }\n}\n\n// ─── Action button (Exclude / Add toggle) ────────────────────────────────────\n\n.diff-action-btn {\n  display: inline-block;\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 2px 10px;\n  border-radius: 4px;\n  border: 1px solid #0669B3;\n  color: #0669B3;\n  background: transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 120ms, color 120ms;\n\n  &:hover {\n    background: #e8f1fb;\n  }\n\n  &--active {\n    background: #0669B3;\n    color: #fff;\n\n    &:hover { background: #0558a0; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
